import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "indicator-label" }
const _hoisted_3 = { class: "indicator-progress" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_5 = { class: "demo-rich-conent w-250px" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder text-success" }, "بالا بردن امتیاز یعنی چی ؟", -1)
const _hoisted_7 = { class: "fs-7" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "indicator-label" }
const _hoisted_10 = { class: "indicator-progress" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_ctx.platformsList[_ctx.platform].calibration_mode)
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        trigger: "hover",
        width: "300"
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              disabled: _ctx.onSubmiting,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.increasePoint && _ctx.increasePoint(...args))),
              ref: "submitButton",
              type: "submit",
              id: "kt_modal_new_card_submit",
              class: _normalizeClass([
            _ctx.classes,
            _ctx.calibration === true ? 'btn-danger' : 'btn-success',
          ])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(!_ctx.calibration
                ? _ctx.translate("فعال سازی بالا بردن امتیاز")
                : _ctx.translate("غیر فعال سازی بالا بردن امتیاز")), 1),
              _createElementVNode("span", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                _hoisted_4
              ])
            ], 10, _hoisted_1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, " در بازه‌های زمانی مختلف، این پلتفرم " + _toDisplayString(_ctx.translate(_ctx.platform)) + " متصل شما، با اکانت‌های مختلف " + _toDisplayString(_ctx.translate(_ctx.platform)) + " اینباکسینو در ساعات مختلف شبانه روز به صورت خودکار شروع به گفتگو می کنند که این فرایند باعث افزایش اعتبار خط شما و بالا بردن تعداد ارسال و هم چنین کاهش احتمال بلاک شدن خط شما می‌شود. ", 1),
              _createElementVNode("button", {
                disabled: _ctx.onSubmiting,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.increasePoint && _ctx.increasePoint(...args))),
                ref: "submitButton1",
                type: "submit",
                id: "kt_modal_new_card_submit1",
                class: _normalizeClass([
              _ctx.classes,
              !_ctx.calibration ? 'btn-success' : 'btn-danger',
              'mt-5 w-100',
            ])
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(!_ctx.calibration
                  ? _ctx.translate("فعال سازی بالا بردن امتیاز")
                  : _ctx.translate("غیر فعال سازی بالا بردن امتیاز")), 1),
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                  _hoisted_11
                ])
              ], 10, _hoisted_8)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}